import { Component, Input } from '@angular/core';
import { BodySchemaZoneValue } from '@bepatient/body-schema-store';

@Component({
  selector: 'bepatient-body-schema-button',
  templateUrl: './body-schema-button.component.html',
  styleUrls: ['./body-schema-button.component.scss'],
  standalone: false
})
export class BodySchemaButtonComponent {
  @Input() color = '#fff';
  @Input() buttonSize = 53;
  @Input() background: string | BodySchemaZoneValue;

  @Input() label: string;
  @Input() border: string;
  @Input() ionIcon: string;
  @Input() svgIcon: string;

  get buttonStyle(): any {
    return {
      width: `${this.buttonSize}px`,
      height: `${this.buttonSize}px`,
      boxShadow: this.border ? 'none' : '0px 0px 10px rgba(0, 0, 0, 0.25)'
    };
  }

  get svgFill(): string {
    if (typeof this.background === 'string' || !this.background) {
      return (this.background as string) || '#fff';
    } else {
      const zone = this.background as BodySchemaZoneValue;
      return (
        `url(` +
        location.protocol +
        `//` +
        location.host +
        location.pathname +
        `#bodySchemaFillPattern${zone.type}${zone.weight})`
      );
    }
  }

  get svgStroke(): string {
    return this.border || 'none';
  }

  get iconStyle(): any {
    return {
      color: this.color,
      fontSize: `${Math.round(this.buttonSize / 2.2)}px`
    };
  }

  get svgIconSrc(): string {
    return `/body-schema/assets/icons/${this.svgIcon}.svg`;
  }
}
